module.exports = __webpack_public_path__ + "img/placeholder.27c93897.jpg";